/**
 * @generated SignedSource<<1f353b92bd1a300b78c80107abac1668>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ExpiringPromoMessage_promotion$data = {
  readonly code: string | null;
  readonly daysRelativeToExpiration: string | null;
  readonly flatAdjustmentRate: {
    readonly rate: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
  } | null;
  readonly percentAdjustmentRate: {
    readonly rate: number | null;
  } | null;
  readonly promotionMeta: {
    readonly urgencyMessagingDaysBeforeExpiration: number | null;
    readonly urgencyMessagingDisplay: boolean | null;
  } | null;
  readonly " $fragmentType": "ExpiringPromoMessage_promotion";
};
export type ExpiringPromoMessage_promotion$key = {
  readonly " $data"?: ExpiringPromoMessage_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExpiringPromoMessage_promotion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExpiringPromoMessage_promotion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "truncate",
          "value": false
        }
      ],
      "kind": "ScalarField",
      "name": "daysRelativeToExpiration",
      "storageKey": "daysRelativeToExpiration(truncate:false)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PromotionMeta",
      "kind": "LinkedField",
      "name": "promotionMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urgencyMessagingDisplay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urgencyMessagingDaysBeforeExpiration",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FlatAdjustmentRate",
      "kind": "LinkedField",
      "name": "flatAdjustmentRate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "rate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ConvertedAmountList",
              "kind": "LinkedField",
              "name": "convertedAmountList",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "amount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currency",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PercentAdjustmentRate",
      "kind": "LinkedField",
      "name": "percentAdjustmentRate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Promotion",
  "abstractKey": null
};

(node as any).hash = "f54fea5795947d07cd4e58d44f6ae605";

export default node;
